import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also send bearer if we have it (fallback for cookie issues)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("access_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// On mobile the access JWT expires after eight hours, while the secure
// refresh cookie remains usable. Retry one time and coalesce concurrent 401s.
let refreshFlight = null;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error?.config;
    if (!original || error?.response?.status !== 401 || original._sessionRetried) {
      return Promise.reject(error);
    }
    const path = String(original.url || "");
    if (/\/auth\/(login|login-pin|refresh|logout|forgot-password|activate-pin)/.test(path)) {
      return Promise.reject(error);
    }
    original._sessionRetried = true;
    if (!refreshFlight) {
      refreshFlight = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true })
        .then(({ data }) => {
          if (!data?.access_token) throw new Error("Refresh tidak mengembalikan token akses");
          localStorage.setItem("access_token", data.access_token);
        })
        .finally(() => { refreshFlight = null; });
    }
    try {
      await refreshFlight;
      return api(original);
    } catch (refreshError) {
      localStorage.removeItem("access_token");
      window.dispatchEvent(new Event("gema:session-expired"));
      return Promise.reject(refreshError);
    }
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && detail.error && typeof detail.error.message === "string") {
    const cid = detail.error.correlation_id ? ` (ID: ${detail.error.correlation_id})` : "";
    return detail.error.message + cid;
  }
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;
